import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { StepApproversComponent } from './steps/step-approvers/step-approvers.component';
import { StepCarConfigComponent } from './steps/step-car-config/step-car-config.component';
import { StepReplacementVehicleComponent } from './steps/step-replacement-vehicle/step-replacement-vehicle.component';
import { StepAdditionalInfoComponent } from './steps/step-additional-info/step-additional-info.component';
import { I18NextModule } from 'angular-i18next';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { RequestType } from '../../model/requestType.enum';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { CarpoolCenterDateData, ModelList } from '../../model/order.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModelStock, Vehicles } from '../../model/vehicle.model';
import { StepVehicleFinderComponent } from './steps/step-vehicle-finder/step-vehicle-finder.component';
import { GenerateNewOrderObj } from '../../utils/generateNewOrderObj';
import { Router } from '@angular/router';
import i18next from 'i18next';
import { MatIconModule } from '@angular/material/icon';
import { StepRequestInfoComponent } from './steps/step-request-info/step-request-info.component';
import { StockVehiclesComponent } from '../stock-vehicles/stock-vehicles.component';
import { StepSummaryComponent } from './steps/step-summary/step-summary.component';
import { CampaignTypes } from '../../model/campaign.enum';
import { StepDocumentationComponent } from './steps/step-documentation/step-documentation.component';
import { UtilsService } from 'src/app/core/services/utils.service';
import { StorageService } from 'src/app/core/storage/storage.service';

@Component({
  standalone: true,
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [
    I18NextModule,
    CommonModule,
    MatStepperModule,
    StepCarConfigComponent,
    StepReplacementVehicleComponent,
    StepApproversComponent,
    StepRequestInfoComponent,
    StepAdditionalInfoComponent,
    StepVehicleFinderComponent,
    MatIconModule,
    StockVehiclesComponent,
    StepSummaryComponent,
    StepDocumentationComponent
  ]
})
export class StepperComponent implements OnInit {
  @Input() user?: any;
  @Input() requestType!: string;
  @Input() steps: Map<string, boolean> = new Map<string, boolean>();
  @Input() leaseEndowType?: string;

  @Output() sendRequestEmitter = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();

  orderType = '';
  isLinear = true;
  modelList?: ModelStock[];
  requestTypeEnum = RequestType;
  subtype = '';
  loanType = '';
  totalDays = 0;
  extraEmail = '';
  extraPhone = '';
  stepTitle = '';
  carPoolCenterDate!: CarpoolCenterDateData;
  existVehicles = false;
  isFirstAssign = false;
  vehiclesArr: Vehicles[] = [];
  controllerDelgatedApproverForm = false;
  vehicleType!: RequestType;
  isApproversCompleted = false;
  resetStep = false;
  moreThan14days = false;
  requestTypeTransfer = '';
  additionalInfo: any;
  documentationInfo: any;
  selectedCar: any;
  campaignType = '';
  campaign: any;
  retribution!: string;
  leasingRetribution = '';
  carType = '';

  @ViewChild('stepper') public stepper!: MatStepper;

  constructor(
    private vehiclesService: VehiclesService,
    private fb: FormBuilder,
    private generateOrderObj: GenerateNewOrderObj,
    private _router: Router,
    private cdr: ChangeDetectorRef,
    private utilsService: UtilsService,
    private storageService: StorageService
  ) {}

  controllerFormGroup: FormGroup = this.fb.group({
    controller: ['', Validators.required]
  });

  controllerDelgatedApproverFormGroup: FormGroup = this.fb.group({
    controller: [, Validators.required],
    delegatedApprover: [, Validators.required]
  });

  vehicleInfoFormGroup: FormGroup = this.fb.group({
    vehicleInfoData: ['', Validators.required]
  });

  replacementVehicleFormGroup: FormGroup = this.fb.group({
    replacementVehicleData: ['', Validators.required]
  });

  vehicleFinderFormGroup: FormGroup = this.fb.group({
    vins: ['', Validators.required],
    redPlate: ['', Validators.required],
    truckPlateNumber: ['', Validators.required]
  });

  requestInfoFormGroup: FormGroup = this.fb.group({
    requestInfoForm: ['', Validators.required]
  });

  ngOnInit(): void {
    this.getVehicles();
    this.requestType === this.requestTypeEnum.judgements ||
    this.requestType === this.requestTypeEnum.transfers ||
    this.requestType === this.requestTypeEnum.redPlates
      ? (this.stepTitle = i18next.t('stepPetitionInfo'))
      : (this.stepTitle = i18next.t('stepRequestInfo'));

    setTimeout(() => {
      this.utilsService.adjustStepper();
    }, 100);
  }

  @HostListener('window:resize')
  onResize() {
    this.utilsService.adjustStepper();
  }

  //Información del peticionario adicional
  onExtraPetitionerDataChange(data: { email: string; phone: string }): void {
    this.extraEmail = data.email;
    this.extraPhone = data.phone;
  }

  //controladores
  updateControllers(data: any) {
    if (data.authorizer?.id) {
      this.controllerDelgatedApproverForm = true;
      this.controllerDelgatedApproverFormGroup.patchValue({
        delegatedApprover: data.authorizer
      });
      this.controllerDelgatedApproverFormGroup.patchValue({
        controller: data.controller
      });
    } else {
      this.controllerFormGroup.setValue({ controller: data.controller });
    }
    this.isApproversCompleted = true;
    this.resetStep = false;
  }

  nextStepApprovers() {
    if (this.isApproversCompleted) {
      this.stepper.next();
    } else {
      this.isApproversCompleted = true;
      this.cdr.detectChanges();
      this.stepper.next();
    }
    this.resetStep = false;
  }

  typeEvent(data: string): void {
    data === 'FUNCTION'
      ? (this.vehicleType = RequestType.function)
      : (this.vehicleType = RequestType.dotArr);
    this.orderType = data;
    this.getVehicles();
  }

  updateCarPoolData(data: any): void {
    this.carPoolCenterDate = data;
  }

  getVehicles() {
    if (
      (this.requestType === this.requestTypeEnum.dotArr ||
        this.requestType === this.requestTypeEnum.campaigns) &&
      !!this.orderType
    ) {
      this.vehiclesService
        .getVehiclesByVehicleTypeAndNIS(this.requestType, this.orderType)
        .subscribe({
          next: (resp) => {
            this.vehiclesArr = resp;
            this.vehiclesArr.length > 0
              ? (this.existVehicles = true)
              : (this.existVehicles = false);
          },
          error: () => {
            this.vehiclesArr = [];
            this.existVehicles = false;
          }
        });
    } else if (this.requestType === this.requestTypeEnum.function) {
      this.vehiclesService
        .getVehiclesByVehicleTypeAndNIS(this.requestType)
        .subscribe({
          next: (resp) => {
            this.vehiclesArr = resp;
            this.vehiclesArr.length > 0
              ? (this.existVehicles = true)
              : (this.existVehicles = false);
          },
          error: () => {
            this.vehiclesArr = [];
            this.existVehicles = false;
          }
        });
    } else if (
      this.requestType === this.requestTypeEnum.didactic ||
      this.requestType === this.requestTypeEnum.generalServices
    ) {
      this.vehiclesService.getStockModels().subscribe({
        next: (resp: ModelStock[]) => {
          return (this.modelList = resp);
        }
      });
    }
    if (this.requestType === this.requestTypeEnum.generalServices) {
      this.vehiclesService
        .getVehiclesDepartment(this.user?.department.id, this.requestType)
        .subscribe({
          next: (resp) => {
            this.vehiclesArr = resp;
            this.vehiclesArr.length > 0
              ? (this.existVehicles = true)
              : (this.existVehicles = false);
          },
          error: () => {
            this.vehiclesArr = [];
            this.existVehicles = false;
          }
        });
    } else if (
      this.requestType === this.requestTypeEnum.innerRoute ||
      this.requestType === this.requestTypeEnum.loan
    ) {
      this.vehiclesService.getStockModels().subscribe({
        next: (resp: ModelList[]) => {
          return (this.modelList = resp);
        }
      });
      this.vehiclesService
        .getVehiclesDepartment(
          this.user?.department?.id,
          RequestType.innerRoute
        )
        .subscribe({
          next: (resp) => {
            this.vehiclesArr = resp;
            this.vehiclesArr.length > 0
              ? (this.existVehicles = true)
              : (this.existVehicles = false);
          },
          error: () => {
            this.vehiclesArr = [];
            this.existVehicles = false;
          }
        });
    }
  }

  requestInfoFormUpdate(data: any) {
    this.loanType = data.loanType;
    this.totalDays = data.totalDays;
    this.requestTypeTransfer = this.requestTypeTransfer;
    if (this.requestType === this.requestTypeEnum.loan) {
      this.moreThan14days = data.moreThan14days;
    }
    this.controllerDelgatedApproverFormGroup.reset();
    this.controllerFormGroup.reset();
    this.requestInfoFormGroup.setValue({ requestInfoForm: data });

    this.isFirstAssign = data.subtype === 'FIRST_ASSIGNMENT';
    this.isApproversCompleted = false;
    this.stepper.next();
  }

  updateVehicleInfoData(data: any) {
    this.selectedCar = data.data;
    this.carType = data.type;
    this.vehicleInfoFormGroup.setValue({ vehicleInfoData: data });
    this.stepper.next();
  }

  sendRequest(event: {
    comments: string;
    sendConfirmation: boolean;
    moreThanOneVehicle: boolean;
    emailCheck: boolean;
    leasing: boolean;
    additionalDoc: boolean;
    email: string;
    phone: string;
    requestCarType: string;
    substitutionVin: string;
  }) {
    const newRequestData = this.generateOrderObj.generateOrderObj(
      this.user.nis,
      this.requestType,
      event.comments,
      event.email,
      event.phone,
      this.vehicleFinderFormGroup.value,
      this.requestInfoFormGroup.value.requestInfoForm,
      this.controllerFormGroup.value,
      this.controllerDelgatedApproverFormGroup.value,
      this.vehicleInfoFormGroup.value.vehicleInfoData,
      this.replacementVehicleFormGroup.value,
      event.moreThanOneVehicle,
      this.campaign,
      this.retribution,
      event.emailCheck,
      event.leasing,
      event.additionalDoc,
      this.documentationInfo
    );

    this.sendRequestEmitter.emit(newRequestData);

    if (
      this.requestType === this.requestTypeEnum.loan &&
      event.moreThanOneVehicle
    ) {
      this._router.navigate([], {
        queryParams: {
          moreThanOneVehicle: true
        },
        skipLocationChange: true
      });
      this.stepper.selectedIndex = 1;
    }
  }

  updateReplacementVehicleData(data: any) {
    this.replacementVehicleFormGroup.setValue({ replacementVehicleData: data });
    this.storageService.set('substitutionVin', data.VIN);
    this.stepper.next();
  }

  onVehiclesSelected(data: any) {
    this.selectedCar = data;
    this.vehicleInfoFormGroup.setValue({
      vehicleInfoData: {
        type: 'stock',
        data: data
      }
    });

    if (data.redPlate) {
      this.vehicleFinderFormGroup.get('vins')?.clearValidators();
      this.vehicleFinderFormGroup.get('truckPlateNumber')?.clearValidators();
      this.vehicleFinderFormGroup
        .get('redPlate')
        ?.setValidators(Validators.required);
      this.vehicleFinderFormGroup.patchValue({
        redPlate: data.redPlate,
        vins: '',
        truckPlateNumber: ''
      });
    } else if (data.truckPlateNumber) {
      this.vehicleFinderFormGroup.get('redPlate')?.clearValidators();
      this.vehicleFinderFormGroup
        .get('vins')
        ?.setValidators(Validators.required);
      this.vehicleFinderFormGroup
        .get('truckPlateNumber')
        ?.setValidators(Validators.required);
      this.vehicleFinderFormGroup.patchValue({
        vins: data.vins,
        truckPlateNumber: data.truckPlateNumber,
        redPlate: ''
      });
    } else {
      this.vehicleFinderFormGroup.get('redPlate')?.clearValidators();
      this.vehicleFinderFormGroup.get('truckPlateNumber')?.clearValidators();
      this.vehicleFinderFormGroup
        .get('vins')
        ?.setValidators(Validators.required);
      this.vehicleFinderFormGroup.patchValue({
        vins: data.vins,
        truckPlateNumber: '',
        redPlate: ''
      });
    }

    this.vehicleFinderFormGroup.get('vins')?.updateValueAndValidity();
    this.vehicleFinderFormGroup.get('redPlate')?.updateValueAndValidity();
    this.vehicleFinderFormGroup
      .get('truckPlateNumber')
      ?.updateValueAndValidity();

    if (this.requestType === this.requestTypeEnum.vo) {
      this.sendRequest(data);
    } else {
      this.stepper.next();
    }
  }

  handleCarList(carList: any[]) {
    this.vehicleInfoFormGroup.setValue({
      vehicleInfoData: carList.map((item) => item.id)
    });
    if (this.campaignType === CampaignTypes.RAFFLE) {
      this.selectedCar = carList;
    } else {
      this.selectedCar = carList[0];
    }
    this.stepper.next();
  }

  gotoSummary(info: any) {
    this.additionalInfo = info;
    if (this.additionalInfo?.retribution || this.additionalInfo?.retribution) {
      this.retribution = this.additionalInfo?.retribution;
    }
    if (
      this.requestType === this.requestTypeEnum.dotArr ||
      this.requestType === this.requestTypeEnum.campaigns ||
      this.requestType === this.requestTypeEnum.leasing
    ) {
      this.stepper.next();
    } else {
      const prev = this.requestInfoFormGroup.value.requestInfoForm || {};
      this.requestInfoFormGroup.setValue({
        requestInfoForm: {
          ...prev,
          deliveryLocationChecked: info.deliveryLocationChecked,
          checkMartorell: info.checkMartorell
        }
      });
      this.sendRequest(info);
    }
  }

  saveDoc(info: any) {
    this.documentationInfo = info;
    this.stepper.next();
  }

  onSummaryResponse(summaryInfo: any) {
    if (summaryInfo.confirm) {
      let type = 'ENDOWMENT';
      switch (this.additionalInfo.requestCarType) {
        case 'endowmentLeasingLeasing':
          type = 'LEASING';
          break;
        case 'leasing':
          type = 'SECONDARY_LEASING';
          break;
      }

      if (!!summaryInfo.retribution) {
        this.retribution = summaryInfo.retribution;
      }

      if (this.additionalInfo.substitutionVin) {
        this.replacementVehicleFormGroup.setValue({
          replacementVehicleData: {
            VIN: this.additionalInfo.substitutionVin,
            requestNumber: this.additionalInfo.substitutionRequestNumber,
            estimatedKms: this.additionalInfo.estimatedKms.toString()
          }
        });

        this.requestInfoFormGroup.setValue({
          requestInfoForm: {
            type: type,
            subtype: 'SUBSTITUTION',
            deliveryLocationChecked:
              this.additionalInfo.deliveryLocationChecked,
            checkMartorell: this.additionalInfo.checkMartorell
          }
        });
      } else {
        this.requestInfoFormGroup.setValue({
          requestInfoForm: {
            type: type,
            subtype: 'FIRST_ASSIGNMENT',
            deliveryLocationChecked:
              this.additionalInfo.deliveryLocationChecked,
            checkMartorell: this.additionalInfo.checkMartorell
          }
        });
      }

      if (this.additionalInfo.email)
        this.extraEmail = this.additionalInfo.email;
      if (this.additionalInfo.phone)
        this.extraPhone = this.additionalInfo.phone;

      this.sendRequest({
        comments: this.additionalInfo.comments,
        sendConfirmation: this.additionalInfo.sendConfirmation,
        moreThanOneVehicle: this.additionalInfo.moreThanOneVehicle,
        emailCheck: this.additionalInfo.emailCheck,
        leasing: this.additionalInfo.leasing,
        additionalDoc: this.additionalInfo.additionalDoc,
        email: this.extraEmail,
        phone: this.extraPhone,
        requestCarType: this.additionalInfo.requestCarType,
        substitutionVin: this.additionalInfo.substitutionVin
      });
    } else {
      this.backStep();
    }
  }

  backStep() {
    if (this.stepper.selectedIndex === 0) return this.initStep();
    this.isApproversCompleted = false;
    this.resetStep = true;

    this.stepper.previous();
  }

  initStep() {
    this.onCancel.emit();
  }

  setCampaign(campaign: any) {
    this.campaignType = campaign.type;
    this.campaign = campaign;
  }
}
